// This file was automatically generated from appanalytics.dialog.bulkLetterDownload.html.
// Please don't edit this file by hand.

goog.provide('el8.template.appanalytics.dialog.bulkLetterDownload');

goog.require('soy');
goog.require('soy.StringBuilder');


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appanalytics.dialog.bulkLetterDownload.content = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="el8DialogContainer"><div class="el8LargeFontSize" style="text-align: center">Please wait, your file is processing. This may take a few minutes.<div class="el8Loading" style="text-align: center;"></div></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appanalytics.dialog.bulkLetterDownload.done = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="el8DialogContainer"><div class="el8LargeFontSize" style="text-align: center; padding-top: 38px;"><a href="', soy.$$escapeHtml(opt_data.url), '" target="_blank" rel="noopener"><button class="el8Button">Download ', soy.$$escapeHtml(opt_data.name), '</button></a></div></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appanalytics.dialog.bulkLetterDownload.noOutput = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="el8DialogContainer"><div class="el8LargeFontSize" style="text-align: center; padding-top: 38px;">', soy.$$escapeHtml(opt_data.name), ' not available for this bulk letter.</div></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appanalytics.dialog.bulkLetterDownload.error = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="el8DialogContainer"><div class="el8LargeFontSize" style="text-align: center; padding-top: 30px;">', soy.$$escapeHtml(opt_data.name), ' could not be created. <br>Please contact us using the "I need help" link at the top of the page.</div></div>');
  if (!opt_sb) return output.toString();
};
